// login api
const login = "auth/";
const addStaff = "users/admin/add-staff";
const getStaffUsers = "users/admin/staff/";
const updateStaffUser = "users/admin/staff-update";
const deleteStaffUser = "users";

const teamLogin = "auth/company/team";
const quote = `quote`;
const imageUpload = `image/upload`;
const createCompanyMember = "users/company-admin/add-member";
const editCompanyMember = "users/company-admin/members-update";
const getCompanyMember = "users/company-admin/members";
const getLeadLink = "quote/link";
const createLeads = "lead/create";
const getLeads = "lead/all";
const updateLeads = "lead/update-status";
const updateLeadStatus = "lead/update-status/";
const createLeadProposal = "lead/send-proposal/";
const createLeadDate = "lead/schedule-follow/";
const createClient = "client/create";
const loginClient = "auth/company/client";
const checkClientEmail = "users/client/check-email";
const getAllClients = "client/all/";
const leadSignup = "lead/signup-request";
const checkTeamMemberEmail = "users/member/check-email";
const getClientProposal = "lead/proposal";
const updateClientDetails = "client/update";
const updateClientDetailsByAdmin = "client/edit/";
const getClientDetails = "client/detail/";
const acceptStatusProposal = "lead/accept-proposal/";
const getPackages = "package/all";
const getUser = "users/me";
////// payment api //////
const paymentCheckout = "payment/checkoutsession";
const paymentKey = "payment/key";
const compeleteSubscription = "payment/complete-subscription";
const updateSubscription = "payment/updateSubscription";
const cancelSubscription = "payment/cancelSubscription";
const taskCrud = "task/";
const taskComment = "task/comment/";
const saveProposal = "lead/save-proposal";
const editProposalService = "service/";
const getProposalService = "service/current/";
const serviceSaveHistory = "service/save/history/";
const getServiceHistroy = "service/history/";
const documentsCrud = "document/";
const uploadFileApi = "file/upload";
const updatepayinvoice = "payment/payinvoice";

//team member
const taskAssign = "teamtask";
const editTask = "teamtask/edit/";
const getTask = "teamtask/";
const updateStatus = "teamtask/update-status/";
const updateComment = "teamtask/comment";
const teamMetrices = "teamtask/dashboard";

// email configure apis
const emailConfigureCreate = "email-conf/save";
const emailConfigureSend = "email-conf/send";
const emailConfigureGet = "email-conf";
const getCompanies = "users/admin/company";
const changeClientPassword = "client/edit";

// chat api start
const getAllConversation = "auction/conversations";
const getUserMessages = "auction/messages";
const seenMessage = "/seen-msg";
const chatUserConversation = "users/conversations";
// chat api ended

const verifyAccount = "payment/verifyAccount";
const createAccountStripe = "payment/createAccount";
const createPaymentStripe = "payment/create";
const companyEditProfile = "users/company-admin/update";
const paymentProposals = "payment/proposal";
const paymentHistory = "payment/history";

// metrices api
const leadMetrices = "lead/dashboard";
const clientMetrices = "lead/client-dashboard";
const askPayment = "payment/request/taxsubmission/amount";
const updatePayment = "payment/updateRequest";
const sendOtherProposal = "lead/send-other-proposal";
const taskMetrices = "teamtask/member/dashboard";

// notification api
const getNotification = "notification/all";
const seenNotification = "notification/check-seen";
const deleteNotification = "notification/";

// privacy api
const getPrivacyPolicy = "pages/privacy";
const getTerms = "pages/terms";

//Support api
const createSupport = "support/create";
const getSupports = "support/admin/";
const attendSupport = "support/attended";

// Faqs Apis
const faqCrud = "pages/faqs";
const faqCatCrud = "pages/faqcat";

//payment api
const getCompaniesSubscriptions = "users/company/subscriptions-transactions";
const getSubscriptionCard = "payment/cardDetails";
const paymentAddCard = "payment/add-card";

// Bank api
const bankGet = "bank";
const bankPost = "bank/create";
const bankPut = "bank/";
const bankDelete = "bank/";

const createCat = "cat/create";
const editCat = "cat/edit";
const allCat = "cat/admin-all";
const catStatus = "cat";
const allCatUsingPaging = "cat/admin";
const changeStatusCat = "cat/active";
const createNewLot = "lot/create";
const editLot = "lot/edit";
const getAllLots = "lot/admin/";
const getWithoutPagingLot = "lot/admin-all";
const updateLotStatus = "lot";

// Registration Fees APIs
const createRegistrationFee = "registration-fees/";
const getRegistrationFees = "registration-fees/";
const getRegistrationFeeDetail = "registration-fees/";
const updateRegistrationFee = "registration-fees/";
const deleteRegistrationFee = "registration-fees/";
const markRegistrationFeePaid = "registration-fees/";





const createNewAuction = "auction/create";
const editAuction = "auction/edit";
const updateAuctionStatus = "auction";
const getAllAuctionUsingPaging = "auction/admin/";
const adminEditAuctionStatus = "auction/admin/edit-registration/";
const auctionStatus = "auction";
const selectAuctionLot = "auction/lot-select";
const getAuctionDetail = "auction/details";
const editAuctionApplication = "auction/admin/edit-registration";
const deleteAuctionApplication = "applications/admin/delete";
const auctionBidWinners = "auction/admin/winners/";
const orderUpdate = "auction/order/update";
const bidWinnerDetail = "auction/admin/winner-detail";

// ==================== WINNER ANNOUNCEMENT & AUCTION ENDING ROUTES ====================
const announceWinner = "auction/announce-winner";
const endAuction = "auction/end-auction";
const autoAnnounceWinners = "auction/auto-announce-winners";
const getWinnerStats = "auction/winner-stats/";
const getLiveChat = "msg/liveChat";
const auctionRegistrationTracking = "auction/admin/registration/";
const createAuctionRegistration = "auction/registration/";
const editAuctionRegistration = "auction/edit-registration";
const getAuctionRegistration = "auction/admin/registration-detail";
const getApprovedRegisteredUsers = "auction/admin/registration";
const getFilledInvoiceIds = "auction/filled-invoice-ids/";
const privacyPages = "users";
const getInvoiceDetail = "auction/order/details";
const updateUser = "users/update-user";
const sendInvoice = "auction/send-invoice";
const getInvoices = "auction/admin/invoices/";
const editInvoice = "auction/update-invoice";
const updateTransaction = "auction/admin-invoice/update";
const footerCrud = "users/footer";
const footerImageUpload = "image/catimage";
const dashboardMetrices = "users/dashboard";
const lotMetrices = "lot/dashboard";
const auctionMetrices = "auction/dasboard";
const paymentInvoicesMetrices = "auction/dasboardPaymentInvoices";
const cashierMetrices = "auction/dashboardCashier";
const clearanceMetrices = "auction/dashboardClearance";
const auctioneerMetrices = "auction/dashboardAuctioneer";
const getSubscribeEmails = "support/subscribe/admin";
const sendUpdates = "support/sendUpdatesEmail";
const sendAuctionNotification = "support/sendAuctionNotification";
const refundProcess = "admin/deposits/process-refund";
const stripeRefund = "admin/deposits/process-stripe-refund";
const addToWallet = "admin/deposits/add-to-wallet";
const subCatCreate = "subcat/create";
const allSubCat = "subcat/admin-all";
const getPaginatedSubCat = "subcat/admin";
const editSubCat = "subcat/edit";
const subCatStatusUpdate = "subcat/";

// Seller Management APIs
const createSeller = "seller/create";
const getSellers = "seller/admin/";
const updateSeller = "seller/update/";
const deleteSeller = "seller/delete/";
const getSellerDetail = "seller/detail/";
const sellerMetrices = "seller/dashboard";

// Buyer Management APIs (using users with type: customer)
const createBuyer = "users/admin/add-customer";
const createBuyerFallback = "users/admin/add-staff"; // Fallback to staff endpoint
const getBuyers = "users/all?type=customer"; // Updated endpoint
const updateBuyer = "users/update-user/"; // Updated endpoint
const deleteBuyer = "users/"; // Updated endpoint (DELETE /api/users/{id})
const getBuyerDetail = "users/detail/"; // Updated endpoint
const buyerMetrices = "users/dashboard"; // Updated endpoint

// Auction Management APIs
const getAuctions = "auctions/";

// Deposits Management APIs
const getDeposits = "deposits/";
const createDeposit = "deposits/";
const updateDeposit = "deposits/";
const deleteDeposit = "deposits/";
const getDepositDetail = "deposits/";
const depositMetrics = "deposits/dashboard";

// Settlements Management APIs
const getSettlements = "settlements/";
const createSettlement = "settlements/";
const updateSettlement = "settlements/";
const deleteSettlement = "settlements/";
const getSettlementDetail = "settlements/";
const settlementMetrics = "settlements/dashboard";

// Fallback endpoints (if the above don't exist yet)
const getBuyersFallback = "users/admin/staff/"; // Try existing staff endpoint first
const getBuyersFallback2 = "users/"; // Generic users endpoint
const getBuyerDetailFallback = "users/";

export {
  updateAuctionStatus,
  catStatus,
  subCatCreate,
  allSubCat,
  getPaginatedSubCat,
  editSubCat,
  subCatStatusUpdate,
  refundProcess,
  stripeRefund,
  addToWallet,
  sendUpdates,
  getSubscribeEmails,
  sendAuctionNotification,
  cashierMetrices,
  clearanceMetrices,
  auctioneerMetrices,
  paymentInvoicesMetrices,
  auctionMetrices,
  lotMetrices,
  updateLotStatus,
  dashboardMetrices,
  faqCatCrud,
  faqCrud,
  footerImageUpload,
  footerCrud,
  updateTransaction,
  editInvoice,
  getInvoices,
  sendInvoice,
  updateUser,
  getInvoiceDetail,
  privacyPages,
  getAuctionRegistration,
  createAuctionRegistration,
  editAuctionRegistration,
  getApprovedRegisteredUsers,
  getFilledInvoiceIds,
  getLiveChat,
  bidWinnerDetail,
  orderUpdate,
  auctionBidWinners,
  editAuctionApplication,
  deleteAuctionApplication,
  getAuctionDetail,
  login,
  changeStatusCat,
  allCat,
  allCatUsingPaging,
  createNewLot,
  getAllLots,
  editLot,
  getWithoutPagingLot,
  editAuction,
  createNewAuction,
  getAllAuctionUsingPaging,
  auctionRegistrationTracking,
  adminEditAuctionStatus,
  auctionStatus,
  addStaff,
  getStaffUsers,
  updateStaffUser,
  deleteStaffUser,
  createCat,
  editCat,
  verifyAccount,
  quote,
  askPayment,
  getCompaniesSubscriptions,
  createAccountStripe,
  sendOtherProposal,
  getLeads,
  getSubscriptionCard,
  paymentAddCard,
  updateLeads,
  getAllConversation,
  updatePayment,
  getUserMessages,
  seenMessage,
  chatUserConversation,
  getUser,
  imageUpload,
  getLeadLink,
  createPaymentStripe,
  serviceSaveHistory,
  getPackages,
  paymentCheckout,
  paymentKey,
  compeleteSubscription,
  createLeads,
  updateSubscription,
  cancelSubscription,
  leadSignup,
  createCompanyMember,
  acceptStatusProposal,
  getCompanyMember,
  editCompanyMember,
  updateLeadStatus,
  createLeadProposal,
  createLeadDate,
  createClient,
  loginClient,
  checkClientEmail,
  checkTeamMemberEmail,
  getAllClients,
  changeClientPassword,
  getClientProposal,
  updateClientDetails,
  updateClientDetailsByAdmin,
  teamLogin,
  getClientDetails,
  saveProposal,
  editProposalService,
  getProposalService,
  getServiceHistroy,
  taskCrud,
  taskComment,
  documentsCrud,
  uploadFileApi,
  taskAssign,
  editTask,
  getTask,
  updateStatus,
  updateComment,
  emailConfigureGet,
  emailConfigureSend,
  emailConfigureCreate,
  getCompanies,
  clientMetrices,
  leadMetrices,
  paymentHistory,
  paymentProposals,
  companyEditProfile,
  getNotification,
  deleteNotification,
  seenNotification,
  updatepayinvoice,
  getPrivacyPolicy,
  getTerms,
  teamMetrices,
  attendSupport,
  getSupports,
  createSupport,
  taskMetrices,
  selectAuctionLot,
  bankGet,
  bankPost,
  bankPut,
  bankDelete,
  announceWinner,
  endAuction,
  autoAnnounceWinners,
  getWinnerStats,
  // Seller Management
  createSeller,
  getSellers,
  updateSeller,
  deleteSeller,
  getSellerDetail,
  sellerMetrices,
  // Buyer Management
  createBuyer,
  createBuyerFallback,
  getBuyers,
  updateBuyer,
  deleteBuyer,
  getBuyerDetail,
  buyerMetrices,
  // Fallback endpoints
  getBuyersFallback,
  getBuyersFallback2,
  getBuyerDetailFallback,
  // Registration Fees
  createRegistrationFee,
  getRegistrationFees,
  getRegistrationFeeDetail,
  updateRegistrationFee,
  deleteRegistrationFee,
  markRegistrationFeePaid,
  // Auction Management
  getAuctions,
  // Deposits Management
  getDeposits,
  createDeposit,
  updateDeposit,
  deleteDeposit,
  getDepositDetail,
  depositMetrics,
  // Settlements Management
  getSettlements,
  createSettlement,
  updateSettlement,
  deleteSettlement,
  getSettlementDetail,
  settlementMetrics,
};
